import React from 'react';
import _ from 'lodash';
import { Box, Card, CardHeader, CardContent, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { Logo } from '../../components-core/landing/Logo';

export const TransactionWrong = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = searchParams.get('params');

  return (
    <Card sx={{ height: '100%' }}>
      <Logo />
      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
        <CardHeader title="Transakcja nie zrealizowana " sx={{ mt: 5 }} />
        <CardContent>
          <Typography>Płatność dotycząca zapisu: <b>{!_.isEmpty(params) ? params.split(';')[0] : ''}</b></Typography>
          <Typography>Na kwotę: <b>{!_.isEmpty(params) ? params.split(';')[1] : ''} zł</b></Typography>
          <Typography>Status: <b style={{ color: 'red' }}>Błąd</b></Typography>
          <p>&nbsp;</p>
          <p>Możesz teraz zamknąć tę stronę lub wrócić na stronę: <a href="https://zapisy.jujutsupoland.com/">https://zapisy.jujutsupoland.com</a> </p>
          <p>W przypadku pytań lub wątpliwości prosimy o kontakt mailowy lub telefoniczny: <b>+48 502 080 348</b> lub <b>zapisy@jujutsupoland.com</b></p>
        </CardContent>
      </Box>
    </Card>
  );
};
